import { StyledContainer, StyledContainerXScroll } from "./Container.styles";

interface ContainerProps {
  children?: any;
}

export const Container: React.FC<ContainerProps> = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export const ContainerXScroll: React.FC<ContainerProps> = ({ children }) => {
  return <StyledContainerXScroll>{children}</StyledContainerXScroll>;
};
